<template>
  <div id="app">
    <!--img alt="Vue logo" src="./assets/logo.png" /-->
    <Header/>
		<About/>
		<Facts/>
		<Stats/>
		<Screenshots/>
		<!--Different/-->
		<Message/>
		<Footer/>
  </div>
</template>

<script>

export default {
  name: "app",
  components: {
    Header: () => import('./components/Header.vue'), 
    About: () => import('./components/About.vue'), 
    Facts: () => import('./components/Facts.vue'), 
    Stats: () => import('./components/Stats.vue'), 
    Screenshots: () => import('./components/Screenshots.vue'),
    Different: () => import('./components/Different.vue'), 
    Message: () => import('./components/Message.vue'), 
    Footer: () => import('./components/Footer.vue'), 
    Chart: () => import('./components/Chart.vue')
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: 'icomoon';
  src:  url('assets/fonts/icomoon.eot?oqsi8e');
  src:  url('assets/fonts/icomoon.eot?oqsi8e#iefix') format('embedded-opentype'),
    url('assets/fonts/icomoon.ttf?oqsi8e') format('truetype'),
    url('assets/fonts/icomoon.woff?oqsi8e') format('woff'),
    url('assets/fonts/icomoon.svg?oqsi8e#icomoon') format('svg');
  font-weight: normal;
  font-style: normal;
}

[class^="icon-"], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-mail:before {
  content: "\e90f";
}
.icon-fax:before {
  content: "\e903";
}
.icon-twitter:before {
  content: "\e90e";
}
.icon-skype:before {
  content: "\e90c";
}
.icon-brand:before {
  content: "\e90c";
}
.icon-social:before {
  content: "\e90c";
}
.icon-facebook:before {
  content: "\e90d";
}
.icon-brand1:before {
  content: "\e90d";
}
.icon-social1:before {
  content: "\e90d";
}
.icon-phone:before {
  content: "\e904";
}
.icon-telephone:before {
  content: "\e904";
}
.icon-contact:before {
  content: "\e904";
}
.icon-support:before {
  content: "\e904";
}
.icon-call:before {
  content: "\e904";
}
.icon-location:before {
  content: "\e909";
}
.icon-map-marker:before {
  content: "\e909";
}

.icon-info::before{
  content: 'ⓘ';
}
.icon-pin:before {
  content: "\e909";
}
.icon-linkedin:before {
  content: "\e90a";
}
.icon-brand2:before {
  content: "\e90a";
}
.icon-social2:before {
  content: "\e90a";
}
.icon-home:before {
  content: "\e90b";
}
.icon-house:before {
  content: "\e90b";
}
.icon-cloud:before {
  content: "\e908";
}
.icon-meter:before {
  content: "\e905";
}
.icon-gauge:before {
  content: "\e905";
}
.icon-dashboard:before {
  content: "\e905";
}
.icon-speedometer:before {
  content: "\e905";
}
.icon-performance:before {
  content: "\e905";
}
.icon-lock:before {
  content: "\e906";
}
.icon-secure:before {
  content: "\e906";
}
.icon-private:before {
  content: "\e906";
}
.icon-encrypted:before {
  content: "\e906";
}
.icon-happy:before {
  content: "\e907";
}
.icon-emoticon:before {
  content: "\e907";
}
.icon-smiley:before {
  content: "\e907";
}
.icon-face:before {
  content: "\e907";
}
.icon-credit-card:before {
  content: "\e902";
}
.icon-wallet:before {
  content: "\e900";
}
.icon-explore:before {
  content: "\e901";
}


#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
	scroll-behavior: smooth;
	max-width: 100vw;
	overflow: hidden;
  //reset
}

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
	scroll-behavior: smooth;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
body {
	line-height: 1;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
</style>
